const API_BASE = (
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  "https://api.vibe2nite.com"
).replace(/\/$/, "");

const WALLET_KEY = "v2n_vibe_points_wallet_id";
const CLIENT_CAP_PREFIX = "v2n_vibe_points_client_cap";

function createWalletId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return `wallet-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getVibePointsWalletId() {
  if (typeof window === "undefined") return "";

  try {
    const existing = window.localStorage.getItem(WALLET_KEY);

    if (existing) return existing;

    const next = createWalletId();
    window.localStorage.setItem(WALLET_KEY, next);
    return next;
  } catch {
    return createWalletId();
  }
}

function todayKey() {
  return new Date().toISOString().slice(0, 10);
}

function clientCapKey(action, venueId = "") {
  return `${CLIENT_CAP_PREFIX}:${todayKey()}:${action}:${venueId || "global"}`;
}

function shouldSkipClientCall(action, venueId) {
  if (typeof window === "undefined") return false;

  try {
    const key = clientCapKey(action, venueId);
    const cappedActions = new Set([
      "first_visit_bonus",
      "daily_visit",
      "events_view",
      "venue_view",
      "directions_click",
      "share_click",
    ]);

    if (!cappedActions.has(action)) return false;
    if (window.sessionStorage.getItem(key)) return true;

    window.sessionStorage.setItem(key, "1");
    return false;
  } catch {
    return false;
  }
}

export async function getVibePointsWallet() {
  const walletId = getVibePointsWalletId();

  if (!walletId) {
    return {
      wallet_id: "",
      vibe_points: 0,
      recent_actions: [],
      rewards_status: "Rewards coming soon",
      no_cash_value: "Vibe2Nite Points have no cash value",
    };
  }

  try {
    const response = await fetch(
      `${API_BASE}/api/rewards/vibe-points/wallet/${encodeURIComponent(walletId)}`
    );

    if (!response.ok) throw new Error("wallet unavailable");
    return response.json();
  } catch {
    return {
      wallet_id: walletId,
      vibe_points: 0,
      recent_actions: [],
      rewards_status: "Rewards coming soon",
      no_cash_value: "Vibe2Nite Points have no cash value",
    };
  }
}

export async function trackVibePoints(action, params = {}) {
  if (typeof window === "undefined") return null;

  const walletId = getVibePointsWalletId();
  const venueId = params.venue_id || params.venueId || null;

  if (!walletId || shouldSkipClientCall(action, venueId)) return null;

  try {
    const response = await fetch(`${API_BASE}/api/rewards/vibe-points/earn`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      keepalive: true,
      body: JSON.stringify({
        wallet_id: walletId,
        action,
        venue_id: venueId,
        page_path: params.page_path || window.location.pathname || "/",
      }),
    });

    if (!response.ok) return null;

    const result = await response.json();

    try {
      window.dispatchEvent(
        new CustomEvent("vibe-points-updated", {
          detail: result,
        })
      );
    } catch {
      // Ignore event dispatch issues. Points must never affect navigation.
    }

    return result;
  } catch {
    return null;
  }
}
